
<app-orderhistorylines-page
  [orderHistoryLines]="orderHistoryLines$ | async"
  [orderHistoryItem]="orderHistoryItem$ | async"
  [cartProducts]="cartProducts$ | async"
  [loading]="loading$ | async"
  [expanding]="expanding$ | async"
  [reOrderableProductCodes]="reOrderableProductCodes$ | async"
  [currency]="currency$ | async"
  (onExpand)="expand()"
  (onReOrder)="reOrder($event)">
</app-orderhistorylines-page>

